export const USER_TYPE = [
  { symbol: 'F' as const, name: 'Free' },
  { symbol: 'W' as const, name: 'Work' },
  { symbol: 'N' as const, name: 'None' },
  { symbol: 'A' as const, name: 'All' },
]

export const DEFAULT_LOCALE = 'en'
